import React from 'react';
import './VideoHero.css';

const VideoHero = () => {
  return (
    <div className="video-hero">
      <video autoPlay loop muted className="video-bg">
        <source src="/videos/hero.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-content">
        <h1>Welcome to Revora</h1>
        <p>Explore the world’s finest luxury cars</p>
      </div>
    </div>
  );
};

export default VideoHero;
